import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { IPatientEnrollmentModel } from "@/Common/Models/Patient/UI/Profile/IPatientEnrollmentModel";
import { RAMQInscription } from "@/Common/Models/RAMQ/RAMQInscription";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { IPatientProfileEnrollmentComponentProps } from "./IPatientProfileComponentProps";

class PatientProfileEnrollmentRepComponent extends React.Component<IPatientProfileEnrollmentComponentProps, any> {
    public render(): JSX.Element {
        var enrolmentModel = this.props.model;
        var ramqInfo: RAMQInscription;

        if (enrolmentModel) {
            ramqInfo = enrolmentModel.get("RAMQInscription");
        }

        return this.GetRepRender(ramqInfo, enrolmentModel, this.props.IsInAddMode || this.props.IsInEditMode);
    }

    private GetRepRender(ramqInfo: RAMQInscription, model: IPatientEnrollmentModel, showAddEdit: boolean): JSX.Element {
        var repRender: JSX.Element = null;

        var availableRepTypes: [string, string][] = [];
        if (model && model.get("AvailableRepType"))
            availableRepTypes = model.get("AvailableRepType");

        if (showAddEdit) {
            repRender = (
                <tbody>
                    <tr>
                        <td className="c1pad form">
                            <span>{cacheStore.GetString("FirstNameLabel")}</span>
                        </td>
                        <td className="c2">
                            <TextboxControl value={model.get("RepFirstName")} className="form-control" operation={LocalPatientOperations.Profile.Enrollment_RepFirstNameChange} />
                        </td>
                    </tr>

                    <tr>
                        <td className="c1pad form">
                            <span>{cacheStore.GetString("LastNameLabel")}</span>
                        </td>
                        <td className="c2">
                            <TextboxControl value={model.get("RepLastName")} className="form-control" operation={LocalPatientOperations.Profile.Enrollment_RepLastNameChange} />
                        </td>
                    </tr>

                    <tr>
                        <td className="c1pad form">
                            <span>{sessionStore.getDefaultHealthCardLabel()}</span>
                        </td>
                        <td className="c2">
                            <TextboxControl value={model.get("RepNam")} className="form-control" operation={LocalPatientOperations.Profile.Enrollment_RepNAMChange} />
                        </td>
                    </tr>

                    <tr>
                        <td className="c1pad form">
                            <span>{cacheStore.GetString("TypeLabel")}</span>
                        </td>
                        <td className="c2">
                            <select onChange={this.onRepTypeChange.bind(this)} className="form-control myle-control" value={model.get("SelectedRepTypeId") ? model.get("SelectedRepTypeId") : ""}>
                                <option value=""> </option>

                                {availableRepTypes.map((p: [string, string]) => (
                                    <option key={p[0]} value={p[0]}> {p[1]}</option>
                                ))}
                            </select>
                        </td>
                    </tr>
                </tbody>
            );
        }
        else if (ramqInfo) {
            repRender = (
                <tbody>
                    <tr>
                        <td className="c1pad form">
                            <span>{cacheStore.GetString("FirstNameLabel")}</span>
                        </td>
                        <td className="c2">
                            <strong>{MyleHelper.ReplaceEmptyString(ramqInfo.RepresentantPrenom)}</strong>
                        </td>
                    </tr>

                    <tr>
                        <td className="c1pad form">
                            <span>{cacheStore.GetString("LastNameLabel")}</span>
                        </td>
                        <td className="c2">
                            <strong>{MyleHelper.ReplaceEmptyString(ramqInfo.RepresentantNom)}</strong>
                        </td>
                    </tr>

                    <tr>
                        <td className="c1pad form">
                            <span>{sessionStore.getDefaultHealthCardLabel()}</span>
                        </td>
                        <td className="c2">
                            <strong>{MyleHelper.ReplaceEmptyString(ramqInfo.RepresentantNam)}</strong>
                        </td>
                    </tr>

                    <tr>

                        <td className="c1pad form">
                            <span>{cacheStore.GetString("TypeLabel")}</span>
                        </td>
                        <td className="c2">
                            <strong>{MyleHelper.ReplaceEmptyString(ramqInfo.RepresentantType)}</strong>
                        </td>
                    </tr>
                </tbody>
            );
        }
        else {
            repRender = (<div />);
        }

        return repRender;
    }

    private onRepTypeChange(e: React.ChangeEvent<HTMLSelectElement>): void {
        var operation = new LocalEvent(LocalPatientOperations.Profile.Enrollment_RepTypeChange);
        operation.AddItem("value", e.target.value);
        LocalEventDispatcher.dispatch(operation);
        e.preventDefault();
    }
}

export { PatientProfileEnrollmentRepComponent };
